export default {
  methods: {
    $numberToFixed(num) {
      return Number(num).toLocaleString("en-US", {maximumFractionDigits: 2});
    },
  },
}